var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 168,
    viewBox: "0 0 220 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2622_54616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.138 146.956C122.508 153.679 97.3983 153.679 72.7687 146.956C70.0471 146.212 68.1641 143.731 68.1641 140.909V75.9634C68.1641 73.1425 70.0471 70.6612 72.7687 69.9178C97.3973 63.1941 122.509 63.1941 147.138 69.9178C149.86 70.6612 151.743 73.1425 151.743 75.9634V140.91C151.743 143.731 149.86 146.212 147.138 146.956Z",
    fill: "#C5D0D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.138 146.956C122.508 153.679 97.3983 153.679 72.7687 146.956C70.0471 146.212 68.1641 143.731 68.1641 140.909V75.9634C68.1641 73.1425 70.0471 70.6612 72.7687 69.9178C97.3973 63.1941 122.509 63.1941 147.138 69.9178C149.86 70.6612 151.743 73.1425 151.743 75.9634V140.91C151.743 143.731 149.86 146.212 147.138 146.956Z",
    fill: "url(#paint0_linear_2622_54616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.861 69.5839C145.358 69.4515 144.855 69.3201 144.352 69.193C144.013 69.1086 143.674 69.0253 143.336 68.9431C142.847 68.8224 142.357 68.706 141.867 68.5906C141.524 68.5105 141.181 68.4325 140.839 68.3545C140.348 68.2435 139.858 68.1367 139.368 68.0309C139.029 67.9583 138.691 67.8856 138.352 67.8152C137.847 67.7105 137.34 67.6101 136.834 67.5107C136.513 67.4477 136.192 67.3836 135.871 67.3228C135.315 67.2181 134.76 67.1187 134.206 67.0205C133.934 66.9724 133.663 66.9222 133.392 66.8752C132.566 66.7342 131.74 66.5996 130.915 66.4747C130.9 66.4725 130.885 66.4704 130.87 66.4672C130.058 66.3444 129.246 66.229 128.435 66.1201C128.161 66.0827 127.888 66.0506 127.615 66.0154C127.06 65.9438 126.504 65.8744 125.949 65.8092C125.626 65.7718 125.304 65.7377 124.981 65.7024C124.474 65.6469 123.966 65.5935 123.458 65.5433C123.119 65.5102 122.779 65.4792 122.438 65.4482C121.946 65.4034 121.452 65.3606 120.959 65.3222C120.614 65.2944 120.268 65.2677 119.923 65.2431C119.431 65.2079 118.939 65.1748 118.447 65.1449C118.105 65.1235 117.763 65.1021 117.422 65.084C116.914 65.0562 116.405 65.0338 115.898 65.0114C115.576 64.9975 115.252 64.9825 114.93 64.9708C114.372 64.9505 113.814 64.9366 113.257 64.9227C112.984 64.9163 112.712 64.9067 112.44 64.9024C111.612 64.8875 110.782 64.8789 109.954 64.8789H109.953C109.124 64.8789 108.295 64.8875 107.467 64.9024C107.195 64.9077 106.922 64.9163 106.649 64.9227C106.092 64.9366 105.535 64.9505 104.978 64.9708C104.655 64.9825 104.331 64.9975 104.009 65.0114C103.5 65.0338 102.992 65.0562 102.485 65.084C102.144 65.1021 101.802 65.1235 101.461 65.1449C100.969 65.1748 100.477 65.2079 99.9842 65.2431C99.6382 65.2677 99.2932 65.2944 98.9482 65.3222C98.4547 65.3606 97.9612 65.4044 97.4688 65.4482C97.1292 65.4792 96.7895 65.5102 96.4488 65.5433C95.9414 65.5924 95.433 65.6469 94.9257 65.7024C94.6031 65.7377 94.2805 65.7718 93.9579 65.8092C93.4025 65.8733 92.8471 65.9438 92.2917 66.0154C92.0193 66.0506 91.7459 66.0827 91.4735 66.119C90.6617 66.2279 89.851 66.3433 89.0403 66.4672C89.0243 66.4693 89.0083 66.4715 88.9923 66.4736C88.1666 66.5996 87.341 66.7342 86.5164 66.8752C86.2451 66.9211 85.9738 66.9724 85.7025 67.0205C85.1471 67.1187 84.5917 67.2181 84.0362 67.3228C83.7158 67.3836 83.3954 67.4477 83.0749 67.5107C82.5676 67.6101 82.0613 67.7105 81.555 67.8152C81.2164 67.8856 80.8778 67.9583 80.5392 68.0309C80.049 68.1367 79.5598 68.2435 79.0706 68.3545C78.7266 68.4315 78.3827 68.5105 78.0388 68.5906C77.5496 68.7049 77.0615 68.8224 76.5723 68.942C76.2337 69.0243 75.8951 69.1076 75.5565 69.193C75.0534 69.3191 74.5503 69.4515 74.0472 69.5839C73.7257 69.6683 73.4053 69.7516 73.0849 69.8382C72.9428 69.8766 72.8018 69.9172 72.6598 69.9557C71.1505 70.3979 69.9094 71.3762 69.1168 72.6494C96.1294 80.7703 123.78 80.7703 150.793 72.6494C150 71.3762 148.759 70.3979 147.249 69.9557C147.108 69.9172 146.966 69.8766 146.824 69.8382C146.503 69.7516 146.181 69.6683 145.861 69.5839Z",
    fill: "#E0E0E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.082 106.617C121.082 100.208 115.665 95.0651 109.16 95.5158C103.684 95.895 99.2451 100.326 98.8542 105.801C98.5733 109.751 100.355 113.3 103.231 115.482C105.197 116.974 106.297 119.343 106.297 121.811V126.366C106.297 128.38 107.872 130.107 109.885 130.143C111.935 130.181 113.61 128.53 113.61 126.488V121.689C113.61 119.283 114.686 116.971 116.612 115.53C119.325 113.502 121.082 110.264 121.082 106.617Z",
    fill: "url(#paint1_linear_2622_54616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.953 22.7281C98.7898 22.7285 89.709 31.8095 89.709 42.9721V71.7163C88.944 72.2912 86.8301 72.7043 84.3422 72.7043C81.8603 72.7043 79.7506 72.2932 78.9809 71.7205V42.9721C78.9809 25.8942 92.8745 12.0002 109.953 12V22.7281Z",
    fill: "url(#paint2_linear_2622_54616)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.953 22.7281C121.117 22.7285 130.198 31.8095 130.198 42.9721V71.7163C130.963 72.2912 133.077 72.7043 135.565 72.7043C138.047 72.7043 140.157 72.2932 140.927 71.7205V42.9721C140.927 25.8942 127.032 12.0004 109.953 12",
    fill: "url(#paint3_linear_2622_54616)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2622_54616",
    x1: 109.953,
    y1: 64.875,
    x2: 109.953,
    y2: 151.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2622_54616",
    x1: 109.953,
    y1: 95.4883,
    x2: 109.953,
    y2: 130.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2622_54616",
    x1: 109.954,
    y1: 12,
    x2: 109.954,
    y2: 72.7043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.836133,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2622_54616",
    x1: 109.954,
    y1: 12,
    x2: 109.954,
    y2: 72.7043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.836133,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2622_54616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "white",
    transform: "translate(40 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.1b2694a55429877cb11ecef894dae71c.svg";
export { ForwardRef as ReactComponent };